// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-acee957e] .text-input-component .text-input-wrapper{max-height:unset}[data-v-acee957e] .text-input-component .text-input-wrapper .input-scroll-area{height:unset;min-height:72px;max-height:calc(100vh - 400px)}", ""]);
// Exports
module.exports = exports;
